export default __webpack_public_path__ + "device_astro.98a3091a.jpg";